<!--动态操作区域:浏览、评论、点赞-->
<template>
    <div class="info">
        <div>
            <img src="../../../assets/images/common/view.svg" alt="">
            <span>{{browseNumber}}</span>
        </div>
        <div>
            <img src="../../../assets/images/common/message.svg" alt="">
            <span>{{commentNumber}}</span>
        </div>
        <div>
            <img src="../../../assets/images/common/like.svg" alt="">
            <span>{{likeNumber}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // 浏览数量
            browseNumber: {
                default: 0,
            },
            // 评论数量
            commentNumber: {
                default: 0,
            },
            // 点赞数量
            likeNumber: {
                default: 0,
            },
        },
    }
</script>

<style scoped>
    .info {
        display: flex;
        height: 36px;
        font-size: 12px;
        border-top: 1px solid #ddd;
        align-items: center;
    }

    .info div {
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .info div:not(:last-child) {
        border-right: 1px solid #ddd;
    }

    .info div img {
        height: 20px;
        margin-right: 5px;
    }


    .info div span {
        color: #cfcfcf;
    }
</style>